import React, { useEffect } from 'react';
import { Route, Switch, Router, Redirect, useRoute, useLocation } from 'wouter';

import LoadingSvg from '@/components/common/LoadingSvg';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';
import { Cookie } from '@/tscapi/utils/cookie';

import { Navigation } from './Components/Navigation';
import { AddressProvider } from './Context/AddressContext';
import { PaymentProvider } from './Context/PaymentContext';
import { useAccount } from './hooks/useAccount';
import useResize from './hooks/useResize';
import { Address } from './Routes/Address';
import EasyPay from './Routes/Easypay';
import Information from './Routes/Information';
import Newsletter from './Routes/Newsletter';
import { Payment } from './Routes/Payment';
import Profile from './Routes/Profile';

function MyAccount() {
    const cookie: Cookie = new Cookie();
    const breakpoint = useResize();
    const isAuthenticated = useAuthenticated();
    const { data, isFetching, error } = useAccount(isAuthenticated);
    const [location] = useLocation();
    if (!isAuthenticated) {
        //not signed in, redirect to signin
        cookie.TargetUrl = '/pages/myaccount';
        window.location.href = '/pages/signin';
        return null;
    }
    if (isFetching) {
        return (
            <div className="summary" style={{ background: '#fff' }}>
                <div className="loading myaccountLoading">
                    <LoadingSvg />
                </div>
            </div>
        );
    }
    {
        if (error) {
            <div className="summary" style={{ background: '#fff' }}>
                <div className="loading myaccountLoading">
                    <LoadingSvg /> error
                </div>
            </div>;
        }
    }
    return (
        <>
            {data && (
                <Router base="/pages/myaccount">
                    <div className="max-w-[1200px] md:mx-auto md:px-5">
                        <div className="mt-5 flex w-full flex-col justify-start md:flex-row">
                            <aside className="w-full md:w-[270px]">
                                <Navigation />
                            </aside>
                            <div
                                className={`w-full md:w-[calc(100%_-_270px)] md:pl-10 ${
                                    location !== '/pages/myaccount/easypay' ? 'md:max-w-[640px]' : ''
                                }`}
                            >
                                <PaymentProvider>
                                    <Route path="/profile" component={Profile} />
                                </PaymentProvider>
                                <Route path="/information" component={Information} />
                                <Route path="/newsletter" component={Newsletter} />
                                <Route path="/easypay" component={EasyPay} />
                                <PaymentProvider>
                                    <Route path="/paymentcards" component={Payment} />
                                </PaymentProvider>
                                <AddressProvider>
                                    <Route path="/addresses" component={Address} />
                                </AddressProvider>
                                <Route path="/orderstatus" component={() => null} />
                                <Route path="/summary">
                                    <Redirect to="/" />
                                </Route>
                                <Route path="/">{breakpoint == 'mobile' ? <></> : <Redirect to="/profile" />}</Route>
                            </div>
                        </div>
                    </div>
                </Router>
            )}
        </>
    );
}

export default MyAccount;
